import { useLightboxProps } from "../../core/index.js";
export const defaultCaptionsProps = {
    descriptionTextAlign: "start",
    descriptionMaxLines: 3,
    showToggle: false,
};
export const resolveCaptionsProps = (captions) => ({
    ...defaultCaptionsProps,
    ...captions,
});
export function useCaptionsProps() {
    const { captions } = useLightboxProps();
    return resolveCaptionsProps(captions);
}
